import { Link, useLocation } from "react-router-dom";
import logoPlaceholder from "../../assets/companyProfilePlaceholder.jpg";
const CompanyInfo = ({ src, name, id }) => {
  const location = useLocation();

  const telegramdetailPage = location.pathname.startsWith("/tender/telegram");
  return (
    <div className="w-full space-y-3">
      <h1 className="text-xs font-semibold tracking-wider uppercase text-[#3d5984]/50">
        Company Information
      </h1>
      <div className="w-full p-5 bg-white rounded-2xl border border-gray-200/70 shadow-[0_2px_10px_rgba(61,89,132,0.08)] flex flex-col sm:flex-row gap-4 sm:gap-5 items-center sm:justify-between text-[#3d5984]">
        <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-5 text-center sm:text-left">
          <div className="w-[88px] h-[88px] rounded-full overflow-hidden border border-slate-100 bg-slate-50 flex justify-center items-center shrink-0">
            <img
              src={src ? src : logoPlaceholder}
              alt="company logo"
              className="w-full h-full object-cover"
            />
          </div>
          <h1 className="text-base font-semibold">{name}</h1>
        </div>
        {!telegramdetailPage && (
          <Link
            to={`/company/${id}`}
            className="w-full sm:w-auto text-center px-6 py-2.5 rounded-full bg-[#664bc7]/10 text-[#664bc7] font-semibold hover:bg-[#664bc7]/15 transition-colors"
          >
            See Tenders
          </Link>
        )}
      </div>
    </div>
  );
};

export default CompanyInfo;
